import { Modal } from "flowbite-react";
import { RiCloseFill } from "@remixicon/react";

interface NotificationModalProps {
  isOpen: boolean;
  closeModal: () => void;
  title: string;
  description: string;
}

export default function NotificationModal({
  isOpen,
  closeModal,
  title,
  description,
}: NotificationModalProps) {
  return (
    <Modal
      show={isOpen}
      style={{
        zIndex: "9999",
      }}
      position={"top-center"}
      onClose={closeModal}
      className="relative pt-8"
      size={"xl"}
      dismissible
    >
      <div className="flex flex-col w-full overflow-y-auto ">
        <div className="flex flex-col mobile:p-[50px] sm:p-[50px]">
          <RiCloseFill
            className="absolute top-8 right-8 size-[25px] "
            onClick={closeModal}
          />

          <span className="text-xl">{title}</span>
          <span>{description}</span>
        </div>
      </div>
    </Modal>
  );
}
